import type {ReactNode} from 'react';
import {useCopy} from '@platform/ui/config';
import './PurchaseControlsPanel.css';

// One surface for catalog selection and its expandable filters in every purchase view.
export function PurchaseControlsPanel({children,filters}:{children:ReactNode;filters?:ReactNode}){
 const t=useCopy();
 return <section className="purchase-controls-panel" aria-label={t('room.cardView')}>
  <div className="room-purchase-grid">{children}</div>
  {filters}
 </section>;
}
